import PouchDB from "pouchdb-browser";

const localDB = new PouchDB("myLocalDB");
const remoteDB = new PouchDB(
  "http://admin:guerrero2@localhost:5984/mobileclientdb"
);

export { localDB, remoteDB };
